import { Box, Button, Typography } from "@mui/material";
import { StyledProjectCard } from "./projectCard.styled";
import { Briefcase, BriefcaseIcon, Eye } from "@phosphor-icons/react";
import { formatDateToDDMMYYYY, formatDateToYYYYMM } from "../../globals/utils";
import { useNavigate } from "react-router-dom";
import { Project } from "../../models/Project";

type ProjectCardProps = {
  project: Project;
};

export const ProjectCard = ({ project }: ProjectCardProps) => {
  const navigate = useNavigate();

  return (
    <StyledProjectCard status={project.status}>
      <Box className="iconWrapper">
        <BriefcaseIcon size={48} />
      </Box>
      <Box className="infoWrapper">
        <Typography variant="h3">
          PRO-{formatDateToYYYYMM(new Date(project.creationDate))}-
          {project.code}
        </Typography>
        {project.contact && (
          <Typography variant="h4">
            {project.contact.address.street} {project.contact.address.number}{" "}
            {project.contact.address.city}
          </Typography>
        )}
      </Box>
      <Box className="buttonWrapper">
        <Button onClick={() => navigate(`/project/${project.id}`)}>
          <Eye size={24} weight="bold" />
        </Button>
      </Box>
      <Box className="footer">
        <Typography variant="h5">{project.author}</Typography>
        <Typography variant="h5">
          {formatDateToDDMMYYYY(new Date(project.creationDate))}
        </Typography>
      </Box>
    </StyledProjectCard>
  );
};
